﻿import { Banner, Button, Icon } from '@equinor/eds-core-react'
import { clear, warning_outlined } from '@equinor/eds-icons'
import { useStore } from 'jotai'
import { ReactElement, useEffect, useState } from 'react'
import { errorMessagesAtom, removeGlobalErrorMessage } from '@/core/store/globalStore'
import styled from 'styled-components'

export function ErrorDisplayBanner(): ReactElement {
    const [errorMessages, setErrorMessages] = useState<string[]>([])
    const store = useStore()

    useEffect(() => {
        const unsub = store.sub(errorMessagesAtom, () => {
            const messages = store.get(errorMessagesAtom)
            setErrorMessages(messages)
        })

        return () => {
            unsub()
        }
    }, [])

    if (!errorMessages.length) {
        return <></>
    }

    const errorMessage: string = errorMessages[errorMessages.length - 1]

    return (
        <BannerWrapper>
            <Banner>
                <Banner.Icon variant="warning">
                    <Icon data={warning_outlined} />
                </Banner.Icon>
                <Banner.Message>{errorMessage}</Banner.Message>
                <Banner.Actions>
                    <Button
                        id="clear-message"
                        onClick={() => {
                            removeGlobalErrorMessage(errorMessage)
                            setErrorMessages((old) => old.slice(0, old.length - 1))
                        }}
                        variant="ghost_icon"
                    >
                        <Icon data={clear} title="Remove message"></Icon>
                    </Button>
                </Banner.Actions>
            </Banner>
        </BannerWrapper>
    )
}

const BannerWrapper = styled.div<{
    $backgroundColor?: string
    $borderColor?: string
    $color?: string
}>`
    background-color: ${(props) => props.$backgroundColor || '#fff'};
    border: 1px solid ${(props) => props.$borderColor || '#ccc'};
    box-shadow: rgba(0, 0, 0, 0.2) 0 3px 12px;
    color: ${(props) => props.$color || 'initial'};
    margin: 0 0 16px;
    padding: 0;
    position: sticky;
    left: 0 !important;
    z-index: 10000;
    width: 100%;
`
